import { render, staticRenderFns } from "./ProductManagementGoogle.vue?vue&type=template&id=63aaa16a&scoped=true"
import script from "./ProductManagementGoogle.vue?vue&type=script&lang=js"
export * from "./ProductManagementGoogle.vue?vue&type=script&lang=js"
import style0 from "./ProductManagementGoogle.vue?vue&type=style&index=0&id=63aaa16a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aaa16a",
  null
  
)

export default component.exports